import React from 'react';
import { Button, Input, Select } from 'antd';

import TagValueAutoComplete from './TagValueAutoComplete';
import TagKeyAutoComplete from './TagKeyAutoComplete';
import styles from '@src/emp-3.0/components/MappedEventBuilder/MappingRulesBuilder/index.less';
import DeleteSvg from '@icons/mapping-panel/delete-icon.svg';
import { isEmptyOrNotEmptyOp, getOperatorOptions, isOnlyStars } from '@src/emp-3.0/utils';
import { EStringOp, IEventRuleItem } from '@src/emp-3.0/types';
import { CusSelect } from '../MetadataBox/styled';

const RuleItem: React.FC<any> = ({
  rawEventName,
  rule,
  disabled,
  onChange,
  showHeader = true,
  onDelete,
  errorFields = [],
  mappingRules,
  ...rest
}) => {
  const { operatorOptions } = getOperatorOptions();
  const isTagValueEmptyValue = !rule.tag_value.value?.length || rule.tag_value.value[0] === '';
  const isTagKeyEmptyValue = !rule.tag_key.value?.length || rule.tag_key.value[0] === '';
  const isValidEmpty = isTagKeyEmptyValue && isTagValueEmptyValue;
  const isTagValueError =
    errorFields.includes('tag_key_value') && isTagValueEmptyValue && !isValidEmpty;
  const isInvalidTagValue =
    rule.tag_value.op === EStringOp.MATCH_PATTERN &&
    errorFields.includes('match_pattern_error') &&
    isOnlyStars(rule.tag_value.value[0]);

  const tagValueStatus = isTagValueError || isInvalidTagValue ? 'error' : undefined;
  const tagKeyStatus =
    errorFields.includes('tag_key_value') && isTagKeyEmptyValue && !isValidEmpty
      ? 'error'
      : undefined;

  const renderTagValue = () => {
    if (isEmptyOrNotEmptyOp(rule.tag_value.op)) {
      return null;
    }

    if (disabled) {
      return (
        <span
          className={styles.readOnly}
          title={rule.tag_value.join(',')}
          style={{ width: '185px' }}
        >
          {rule.tag_value}
        </span>
      );
    }

    return (
      <div style={{ width: '30%' }}>
        <TagValueAutoComplete
          disabled={disabled}
          rawEventName={rawEventName}
          rule={rule}
          onChange={(value) => {
            rule.tag_value.value = value ? [value] : [];
            onChange(rule);
          }}
          placeholder="Tag Value..."
          filterOption={true}
          status={tagValueStatus}
          mappingRules={mappingRules}
          {...rest}
        />
      </div>
    );
  };

  return (
    <div className={styles.ruleRow}>
      <span className={styles.orWidth}>
        {showHeader && <span className={styles.orTag}>OR</span>}
      </span>
      {/*new workflow remove this by ux requirement.*/}
      {/*<span className={styles.numberTag}>{`${index + 1}.${num + orIndex + 1}`}</span>*/}{' '}
      {disabled ? (
        <span className={styles.readOnly} title={rule.tag_key.value[0]} style={{ width: '123px' }}>
          {rule.tag_key.value[0]}
        </span>
      ) : (
        <div style={{ width: '30%', flexShrink: 1, flexGrow: 0, maxWidth: '30%', minWidth: '30%' }}>
          <TagKeyAutoComplete
            disabled={disabled || rule.disableTagKeySelection}
            rawEventName={rawEventName}
            rule={rule}
            onChange={(value) => {
              rule.tag_key.value = value ? [value] : [];
              onChange(rule);
            }}
            filterOption={true}
            status={tagKeyStatus}
            placeholder="When Tag Key..."
            mappingRules={mappingRules}
            {...rest}
          />
        </div>
      )}
      <CusSelect
        disabled={disabled}
        style={{ margin: '8px', width: 'fit-content', height: '28px', minWidth: '83px' }}
        dropdownMatchSelectWidth={120}
        options={operatorOptions}
        value={rule.tag_value.op}
        onChange={(value) => {
          rule.tag_value.op = value;
          if (value == EStringOp.IS_EMPTY || value === EStringOp.IS_NOT_EMPTY) {
            rule.tag_value.value = [];
          }
          onChange(rule);
        }}
      />
      {renderTagValue()}
      <span className={styles.deleteIcon}>
        <Button
          type="text"
          icon={<DeleteSvg />}
          disabled={disabled || rule.disableTagKeySelection}
          onClick={() => onDelete()}
        />
      </span>
    </div>
  );
};

export default RuleItem;
